/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "ca-central-1",
    "aws_cognito_identity_pool_id": "ca-central-1:c1ebc9ed-8105-48f3-a1d9-80052888ed2a",
    "aws_cognito_region": "ca-central-1",
    "aws_user_pools_id": "ca-central-1_TxjoIawIu",
    "aws_user_pools_web_client_id": "2ufas316bpru4q61pv81gss6ll",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
"aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 12,
        "passwordPolicyCharacters": [
            "REQUIRES_NUMBERS"
        ]
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ]
};


export default awsmobile;
